// extracted by mini-css-extract-plugin
export default {"container":"TemplatesPage_container__4DK7w","button":"TemplatesPage_button__82xx7"};